import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
// Pages
import Home from './pages/Home';
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import ServicesHome from './pages/services/ServicesHome';
import TrainingHome from './pages/training/TrainingHome';
import TrainingDetail from './pages/training/TrainingDetail';
import ServiceDetail from './pages/services/ServiceDetail';
import Mobileapp from './pages/platforms/mobile-applications/Mobileapp.jsx';
import Website from './pages/platforms/websites/Website.jsx';
import SocialMedia from './pages/platforms/SocialMedia/SocialMedia.jsx';
import ClientProjects from './pages/ClientProjects.jsx';
import "./App.css"
import Privacy from './pages/Privacy.jsx';
import Terms from './pages/Terms.jsx';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div className="page-wrapper" key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/clientprojects" element={<ClientProjects />} />
        {/* Services */}
        <Route path="/services" element={<ServicesHome />} />
        <Route path="/services/:serviceType" element={<ServiceDetail />} />
        {/* Training */}
        <Route path="/training" element={<TrainingHome />} />
        <Route path="/training/:programType" element={<TrainingDetail />} />
        {/* Platforms */}
        <Route path="/platforms/mobile-applications" element={<Mobileapp />} />
        <Route path="/platforms/websites" element={<Website />} />
        <Route path="/platforms/social-media" element={<SocialMedia />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
}

export default App;